import { gql } from "@apollo/client";

const GET_ALL_REQUIREMENTS = gql`
  query GET_ALL_REQUIREMENTS {
    allRequirements: getRequirements {
      _id
      name
      expiryType
      archived
    }
  }
`;

const GET_HCP_REQUIREMENTS = gql`
  query GET_HCP_REQUIREMENTS($hcpId: ObjectId!, $filter: RequirementsFilter) {
    hcpRequirementList(hcpId: $hcpId, filter: $filter) {
      _id
      requirement {
        _id
        name
      }
      expiry
    }
  }
`;

const MODIFY_HCP_REQUIREMENTS = gql`
  mutation MODIFY_HCP_REQUIREMENTS(
    $hcpId: ObjectId!
    $newRequirements: [NewHcpRequirementDto!]
    $updatedRequirements: [UpdatedHcpRequirementDto!]
    $removedRequirements: [ObjectId!]
  ) {
    modifiedRequirements: modifyHcpRequirements(
      hcpId: $hcpId
      newRequirements: $newRequirements
      updatedRequirements: $updatedRequirements
      removedRequirements: $removedRequirements
    ) {
      _id
      requirement {
        _id
        name
      }
      expiry
      archived
    }
  }
`;

export { GET_ALL_REQUIREMENTS, GET_HCP_REQUIREMENTS, MODIFY_HCP_REQUIREMENTS };
